import { render, staticRenderFns } from "./NbNewUploaderFilesList.vue?vue&type=template&id=ba05faac&scoped=true&lang=pug"
import script from "./NbNewUploaderFilesList.vue?vue&type=script&lang=ts"
export * from "./NbNewUploaderFilesList.vue?vue&type=script&lang=ts"
import style0 from "./NbNewUploaderFilesList.vue?vue&type=style&index=0&id=ba05faac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba05faac",
  null
  
)

export default component.exports